import React, {Fragment} from "react";
import { formatBirthdate, formatGenderFull, formatHeight, formatWeight } from "../../../helpers/FormatHelper";
import { Patient } from "../../../models/Patient";
import {useTranslation} from "react-i18next";
import {useLongPress} from "../../../hooks";
import {getUserPhotoUrl} from "../../../api/ApiHelper";
import {Avatar} from "@mui/material";

interface PatientProps {
    patient: Patient;
    onClick: () => void;
    onContextMenuHandler: (anchorX: number, anchorY: number) => void;
    onUserClick?: (userId: string) => void;
    compact?: boolean;
}

export const PatientsLong: React.FC<PatientProps> = ({ patient, onClick, onContextMenuHandler, onUserClick, compact = false }: PatientProps) => {
    const {t} = useTranslation();
    const contextMenuHandler = (event : any) => {
        event.preventDefault();
        onContextMenuHandler(event.clientX, event.clientY);
    };
    const userClickHandler = (e : React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (onUserClick && patient.ownerInfo?.ownerId){
            onUserClick(patient.ownerInfo.ownerId);
        }
    };
    // touch: long press opens the context menu (iOS does not fire contextmenu)
    const longPress = useLongPress(onContextMenuHandler);
    return (
        <tr onClick={onClick} onContextMenu={contextMenuHandler} {...longPress}>
            {patient.ownerInfo &&
                <td className="d-flex justify-content-start align-items-center text-left">
                    <Avatar className="user-avatar-img mx-2" alt={patient.ownerInfo.ownerName} src={getUserPhotoUrl(patient.ownerInfo.ownerPhotoUrl)}
                            onClick={compact ? userClickHandler : undefined}/>
                    {!compact &&
                        <div className={`text-tooltip ${onUserClick ? "clickable" : ""}`} onClick={userClickHandler}>{patient.ownerInfo.ownerName}<span>{patient.ownerInfo.ownerEmail}</span></div>
                    }
                </td>
            }
            <td className={`text-left ${compact ? "list-cell-wrap" : ""}`}>
                {patient.name}
                {compact && <div className="list-cell-subtitle">{`${formatBirthdate(patient.birthDate)} · ${formatGenderFull(t, patient.gender)}`}</div>}
            </td>
            {!compact &&
                <Fragment>
                    <td align="center">{formatBirthdate(patient.birthDate)}</td>
                    <td align="center">{patient.phone}</td>
                    <td align="center">{patient.email}</td>
                    <td align="center">{formatGenderFull(t, patient.gender)}</td>
                    <td align="center">{formatHeight(t, patient.height, patient.heightUnits)}</td>
                    <td align="center">{formatWeight(t, patient.weight, patient.weightUnits)}</td>
                </Fragment>
            }
        </tr>
    );
}